/** Возвращает первый непустой URL из media по приоритету ключей. */
export function pickMediaUrl(media, ...priority) {
    if (!media)
        return '';
    for (const key of priority) {
        const value = media[key];
        if (typeof value === 'string' && value.trim())
            return value;
    }
    return '';
}
